<template>
  <div v-show="visible" class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">Wakeups</h2>
    </div>

    <div class="part__cnt">
      <div v-if="labelsHasData" class="label_style mt-3">
        <ul v-for="item in WakeupsValue" :key="item.label">
          <li>{{ item.label }}</li>
          <li>{{ item.value }}</li>
        </ul>
      </div>

      <div v-show="secondData?.Wakeups?.length" class="position-relative">
        <div id="wakeups" style="width: 100%; height: 400px"></div>
        <div id="wakeups_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="wakeups_chart" />
        <chart-rect ref="chartRect1" chartKey="wakeups_chart" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart, arrNotEmpty} from '../common.js'
import ChartRect from '../rect.vue'

const useCharts = {
  props: {
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {
      wakeups_data: [],
    }
  },

  computed: {
    secondData() {
      return this.perf_second_data?.['GPU']?.rows || {}
    },

    xData() {
      return this.gpuRows?.timeline
    },
  },

  methods: {
    getOption() {
      return {
        title: {
          text: "Wakeups",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: [
          {
            name: "Wakeups",
            type: "line",
            showSymbol: false,
            data: this.secondData?.["Wakeups"],
            itemStyle: this.chartSettings.itemStyle2,
          },
        ],
      }
    },

    drawPieChartWakeups() {
      let chartDom = document.getElementById("wakeups")
      if (!chartDom) return
      if (!allChart.wakeups_chart) {
        allChart.wakeups_chart = echarts.init(chartDom)
      }
      allChart.wakeups_chart.setOption(this.getOption(), {notMerge: true})
    },
  }
}

export default {
  mixins: [useCharts],

  components: {LabelList, ChartRect},

  inject: ['injectObj'],

  props: {
    testInfo: Object,
    testInfo3: Object,
  },

  data() {
    return {
      
    }
  },

  computed: {
    project() {
      return this.$route.query.project
    },

    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    WakeupsValue() {
      let data = this.testInfo3

      return [
        {
          label: "Avg(Wakeups)",
          value:
            JSON.stringify(data) === "{}"
              ? "-"
              : data?.custom_data == null ||
                data?.custom_data == undefined ||
                data?.custom_data == "-"
              ? ""
              : JSON.parse(data?.custom_data)?.Wakeups
              ? JSON.parse(data?.custom_data)?.Wakeups
              : "-",
        },
      ];
    },

    labelsHasData() {
      return arrNotEmpty(this.WakeupsValue)
    },

    visible() {
      return this.labelsHasData || this.secondData?.Wakeups?.length
    },
  },

  methods: {
    async init(isMounted) {
      this.drawPieChartWakeups()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>